import { render } from "./WSGateway.vue?vue&type=template&id=1debb6f3&scoped=true"
import script from "./WSGateway.vue?vue&type=script&lang=js"
export * from "./WSGateway.vue?vue&type=script&lang=js"

import "./WSGateway.vue?vue&type=style&index=0&id=1debb6f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1debb6f3"]])

export default __exports__